module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_5_1.a28044ae.png";